import {useMutation} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {GENERATE_QUESTION_GRAPH_JSON} from '../sharedQueries';

export function useGenerateQuestionGraphJson() {
  const [generateQuestionGraphJsonMutation, {loading, error}] = useMutation<
    {generateQuestionGraphJson: string | null},
    {
      questionText: string;
      topic?: string;
      difficulty?: number;
      hint?: string;
      options?: string[];
      answer?: string;
      explanation?: string;
    }
  >(GENERATE_QUESTION_GRAPH_JSON);

  const generateQuestionGraphJson = async (
    questionText: string,
    topic?: string,
    difficulty?: number,
    hint?: string,
    options?: string[],
    answer?: string,
    explanation?: string,
  ) => {
    const result = await generateQuestionGraphJsonMutation({
      variables: {
        questionText,
        topic,
        difficulty,
        hint,
        options,
        answer,
        explanation,
      },
    });

    return extractGqlData(result).generateQuestionGraphJson;
  };

  return {
    generateQuestionGraphJson,
    loading,
    error,
  };
}
